import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c00a15c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "double-page" }
const _hoisted_2 = { class: "double-page-img-box touch-dom" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 目录列表 "),
    _createVNode($setup["chapterListMenu"], {
      onBefore: $setup.before,
      onNext: $setup.next,
      onChangeChapter: $setup.change_chapter
    }),
    _createCommentVNode(" 功能菜单 "),
    _createVNode($setup["rightSidebar"], {
      direction: $setup.directionDesc,
      onDirection: $setup.switch_direction,
      onDwonload: $setup.dwonload_image,
      removeFirst: $setup.removeFirst,
      onRemoveFirst: $setup.remove_poster
    }, null, 8 /* PROPS */, ["direction", "removeFirst"]),
    _createCommentVNode(" 图片容器 "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["bookmark"], {
        page: $setup.page,
        chapterId: $setup.chapterInfo.chapterId
      }, null, 8 /* PROPS */, ["page", "chapterId"]),
      ($setup.directionDesc)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($setup.imgSrc2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "double-page-img",
                  src: $setup.imgSrc2,
                  alt: $setup.t('browse.imgLoadError')
                }, null, 8 /* PROPS */, _hoisted_3))
              : _createCommentVNode("v-if", true),
            _createElementVNode("img", {
              class: "double-page-img",
              src: $setup.imgSrc1,
              alt: $setup.t('browse.imgLoadError')
            }, null, 8 /* PROPS */, _hoisted_4)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("img", {
              class: "double-page-img",
              src: $setup.imgSrc1,
              alt: $setup.t('browse.imgLoadError')
            }, null, 8 /* PROPS */, _hoisted_5),
            ($setup.imgSrc2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "double-page-img",
                  src: $setup.imgSrc2,
                  alt: $setup.t('browse.imgLoadError')
                }, null, 8 /* PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */)),
      _createVNode($setup["operationCover"], {
        onBefore: $setup.beforePage,
        onNext: $setup.nextPage,
        onSwitchMenu: $setup.switch_menu,
        onSwitchFooter: $setup.switch_footer
      })
    ]),
    _createCommentVNode(" 页码显示 "),
    _createVNode($setup["pageNumber"], {
      page: $setup.page,
      count: $setup.count
    }, null, 8 /* PROPS */, ["page", "count"]),
    _createCommentVNode(" 分页按钮 "),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        class: "btn",
        type: "warning",
        plain: "",
        onClick: $setup.before
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.before')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["browsePager"], {
        ref: "pager",
        onPageChange: $setup.page_change,
        onReloadPage: $setup.reload_page,
        page: $setup.page,
        count: $setup.count
      }, null, 8 /* PROPS */, ["page", "count"]),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "success",
        plain: "",
        onClick: $setup.next
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.next')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.config.browseFooter]
    ])
  ]))
}